module.exports = __webpack_public_path__ + "img/13.153d0bb8.svg";